export default function (value) {
    const verifyResultEnum = {
        DIFF_PROJECT: '无效二维码，电子出入证二维码所属项目与当前扫码验真项目不一致',
        QR_EXPIRED: '无效二维码，电子出入证二维码已过期',
        EXPIRED: '电子出入证已过期',
        CANCELLED: '电子出入证已作废',
        INEFFECTIVE: '电子出入证未生效'
    }
    return verifyResultEnum[value] || ''
}
